<div class="flex flex-col gap-2">
  <!-- The partner comes first: the list below is always that partner's. -->
  <guarantees-place-picker
    [service]="service()"
    [initial]="initialPlace()"
    (changed)="choosePlace($event)"
  ></guarantees-place-picker>

  @if (!asked()) {
    <span class="text-sm text-neutral-400">{{ "guaranteeV2.message.pickSuggestionPartner" | translate }}</span>
  } @else if (busy()) {
    <div class="flex items-center gap-2 px-2 py-3 text-sm text-neutral-400">
      <guarantees-spinner></guarantees-spinner>
      {{ "guaranteeV2.message.searchingCandidates" | translate }}
    </div>
  } @else if (failed()) {
    <guarantees-callout
      tone="warning"
      icon="cloud_off"
      stack
    >
      {{ "guaranteeV2.message.candidatesUnavailable" | translate }}
      <button
        class="self-start rounded-full border border-warning-300 px-2 py-0.5 text-sm font-semibold text-warning-800 hover:bg-warning-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none"
        type="button"
        (click)="retry()"
      >
        {{ "guaranteeV2.action.retry" | translate }}
      </button>
    </guarantees-callout>
  } @else {
    <!-- The partner's side failing leaves our own records standing, so it is said beside them. -->
    @if (suggestionsFailed()) {
      <guarantees-callout
        tone="warning"
        icon="cloud_off"
      >
        {{ "guaranteeV2.message.suggestionsUnavailable" | translate }}
      </guarantees-callout>
    }

    @if (empty()) {
      <guarantees-callout
        tone="warning"
        icon="event_busy"
      >
        {{ "guaranteeV2.message.noCandidates" | translate }}
      </guarantees-callout>
    } @else {
      <span class="text-sm text-neutral-400">{{ "guaranteeV2.message.candidatesFound" | translate: { count: bindableCount() } }}</span>

      <!-- One click answers the whole step: the visit states where, who and when all at once. -->
      <ul class="flex flex-col gap-1.5">
        @for (row of rows(); track row.key) {
          <li>
            <button
              type="button"
              [class]="row.className"
              [disabled]="!!row.refusalKey"
              (click)="choose(row)"
            >
              <span class="flex w-full items-center gap-2">
                <mat-icon
                  class="h-4! w-4! shrink-0 text-base! leading-4!"
                  [class]="row.selected ? 'text-primary-600' : 'text-neutral-300'"
                  >{{ row.selected ? "check_circle" : "event" }}</mat-icon
                >

                <span
                  class="shrink-0 text-sm font-semibold tabular-nums"
                  [class]="row.refusalKey ? 'text-neutral-400' : 'text-neutral-700'"
                >
                  {{ row.dateStart | date: "d MMM yy HH:mm" }}
                  @if (row.dateEnd) {
                    <span class="text-neutral-400">– {{ row.dateEnd | date: "HH:mm" }}</span>
                  }
                </span>

                <!-- Said on the row: taking it makes our record rather than pointing at one. -->
                @if (row.suggestion) {
                  <span class="inline-flex shrink-0 items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 text-sm text-primary-700">
                    <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">sync_alt</mat-icon>
                    {{ "guaranteeV2.label.partnerSystemVisit" | translate }}
                  </span>
                }

                @if (row.price !== undefined && !row.refusalKey) {
                  <span class="ml-auto shrink-0 text-sm text-neutral-400 tabular-nums">{{ row.price }}</span>
                }
              </span>

              <span class="grid w-full grid-cols-[auto_1fr] gap-x-2 gap-y-0.5 pl-6 text-sm">
                <span class="text-neutral-400">{{ "guaranteeV2.label.partner" | translate }}</span>
                <span class="min-w-0 truncate text-neutral-600">{{ row.partnerName || "—" }}</span>

                <span class="text-neutral-400">{{ "guaranteeV2.label.location" | translate }}</span>
                <span class="min-w-0 truncate text-neutral-600">{{ row.locationName || "—" }}</span>

                @if (row.doctorName) {
                  <span class="text-neutral-400">{{ "guaranteeV2.label.doctor" | translate }}</span>
                  <span class="min-w-0 truncate text-neutral-600">{{ row.doctorName }}</span>
                }

                @if (row.orderNumber) {
                  <span class="text-neutral-400">{{ "guaranteeV2.label.orderNumber" | translate }}</span>
                  <span class="min-w-0 truncate text-neutral-600 tabular-nums">{{ row.orderNumber }}</span>
                }

                @if (row.serviceName) {
                  <span class="text-neutral-400">{{ "guaranteeV2.label.candidateSubject" | translate }}</span>
                  <span class="min-w-0 truncate text-neutral-600">{{ row.serviceName }}</span>
                }
              </span>

              <!-- Said in the row rather than behind a hover: a row that cannot be clicked cannot be hovered. -->
              @if (row.refusalKey) {
                <span class="flex items-center gap-1 pl-6 text-sm text-neutral-400">
                  <mat-icon class="h-3.5! w-3.5! shrink-0 text-sm! leading-3.5!">block</mat-icon>
                  {{ row.refusalKey | translate }}
                </span>
              }
            </button>
          </li>
        }
      </ul>
    }
  }
</div>
